import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './Footer.css';

function Footer() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <>
            <footer className='footer'>
                <div className='footer-section'>
                    <div className='footer-item' >
                        <img
                            src={require('./assets/footerLogo.webp')}
                            className='footer-logo'
                        />
                    </div>
                    <div className='footer-item'>
                        <h5>{t('footer.contact.title')}</h5>
                        <div className='footer-title-line' />
                        <div className="footer-contact-details">
                            <a
                                href={`mailto:${t('footer.contact.eValue')}`}
                                className="footer-contact-details-item"
                            >
                                <i className="fa-solid fa-globe"></i>
                                <p>{t('footer.contact.eValue')}</p>
                            </a>
                            <a
                                href={`tel:${t('footer.contact.tValue')}`}
                                className="footer-contact-details-item"
                            >
                                <i className="fa-brands fa-whatsapp"></i>
                                <p>{t('footer.contact.tValue')}</p>
                            </a>
                        </div>

                    </div>
                    <div className='footer-item'>
                        <h5>{t('footer.about.title')}</h5>
                        <div className='footer-title-line' />
                        <div className='footer-nav-list'>
                            <Link to={'/about-us#story'} className='footer-nav-list-item'>
                                {t('footer.about.story')}
                            </Link>
                            <Link to={'/about-us#store'} className='footer-nav-list-item'>
                                {t('footer.about.store')}
                            </Link>
                        </div>
                    </div>
                    <div className='footer-item'>
                        <h5>{t('footer.quickLinks.title')}</h5>
                        <div className='footer-title-line' />
                        <div className='footer-nav-list'>
                            <Link to={'/'} className='footer-nav-list-item'>
                                {t('footer.quickLinks.home')}
                            </Link>
                            <Link to={'/products'} className='footer-nav-list-item'>
                                {t('footer.quickLinks.products')}
                            </Link>
                            <Link to={'/contact-us'} className='footer-nav-list-item'>
                                {t('footer.quickLinks.contact')}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <p>
                        &copy; {currentYear} {t('footer.copyright')}
                    </p>
                </div>
            </footer>
        </>
    );
}


export default Footer;